<template>
  <div ref="chartContainer" class="gauge-container">




  </div>


</template>

<script lang="ts" setup>
import { onMounted, ref, watch, onUnmounted } from 'vue';
import * as echarts from 'echarts';


// 添加 rateValue 定义



const props = defineProps<{
  value: number; // 0-100
  title: string;
  state: string;
  mainColor?: string; // 主色
  bgColor?: string;   // 背景色
  trackColor?: string; // 轨道背景色
}>();

const chartContainer = ref<HTMLElement | null>(null);
let myChart: echarts.ECharts | null = null;

const getChartOptions = () => {
  const mainColor = props.mainColor || '#1e87f0';
  // const pointerColor = props.pointerColor || mainColor;
  const trackColor = props.trackColor || '#e6e6e6';
  const bgColor = props.bgColor || 'rgba(255,255,255,0.9)';

  return {
    backgroundColor: bgColor,
    title: {
      show: true,
      text: props.title,
      left: 'center',
      top: '5%',
      textStyle: {
        color: mainColor,
        fontSize: 18,
        fontWeight: 'bold'
      }
    },
    series: [
      // 添加小半圆白色阴影
      {
        type: 'gauge',
        radius: '55%',
        center: ['50%', '75%'],
        startAngle: 180,
        endAngle: 0,
        axisLine: {
          lineStyle: {
            width: 100,
            color: [[1, '#fff']],
            shadowBlur: 10,  // 将阴影效果移到 lineStyle
            shadowColor: 'rgba(0,0,0,0.3)',  // 加深阴影颜色
            shadowOffsetX: 0,
            shadowOffsetY: 2
          }
        },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        pointer: { show: false },
        detail: { show: false },
        itemStyle: {
          color: '#f4f7fc'
        },
        z: 7
      },

      // 外层轨道
      {
        type: 'gauge',
        radius: '90%',
        center: ['50%', '70%'], // 调整中心位置
        startAngle: 190,        // 修改起始角度
        endAngle: -10,            // 修改结束角度
        axisLine: {
          lineStyle: {
            width: 15,
            color: [[1, trackColor]]
          }
        },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        pointer: { show: false },
        detail: { show: false },
        z: 1
      },
      // 进度条
      {
        type: 'gauge',
        radius: '90%',
        center: ['50%', '70%'], // 调整中心位置
        startAngle: 190,        // 修改起始角度
        endAngle: -10,            // 修改结束角度
        data: [{ value: props.value }],
        axisLine: {
          lineStyle: {
            width: 25,
            color: [
              [props.value / 100, mainColor],
              [1, trackColor]
            ]
          }
        },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        pointer: { show: false },
        detail: { show: false }
      },
      // 刻度
      {
        type: 'gauge',
        radius: '98%',
        center: ['50%', '70%'], // 调整中心位置
        startAngle: 190,        // 修改起始角度
        endAngle: -10,            // 修改结束角度
        splitNumber: 10,
        axisLine: { show: false },
        axisTick: {
          show: false,
          splitNumber: 5,
          length: 8,
          lineStyle: {
            color: '#999',
            width: 1
          }
        },
        splitLine: {
          show: true,
          length: 12,
          lineStyle: {
            color: '#fff',
            width: 2
          }
        },
        axisLabel: {
          show: false,
          distance: 5,
          color: '#666',
          fontSize: 12,
          formatter: (value: number) => {
            if (value === 0 || value === 100) return '';
            return value;
          }
        },
        pointer: { show: false },
        detail: { show: false }
      },
      // 指针
      {
        type: 'gauge',
        radius: '120%',
        center: ['50%', '70%'], // 调整中心位置
        startAngle: 190,        // 修改起始角度
        endAngle: -10,            // 修改结束角度
        data: [{ value: props.value }],
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        pointer: {
          show: true,
          width: 4,
          length: '80%',
          itemStyle: {
            color: '#FFF',
            shadowBlur: 5,
            shadowColor: 'rgba(0,0,0,0.9)'
          }
        },
        detail: { show: false },
        z: 2
      },
      // 中心数值
      {
        type: 'gauge',
        center: ['50%', '77%'], // 调整中心位置与小半圆一致
        data: [{ value: props.value }],
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        pointer: { show: false },
        detail: {
          show: true,
          offsetCenter: [0, '-40%'], // 调整垂直位置到小半圆上方
          formatter: `{value|${props.value}}\n{state|${props.state}}\n{stars|★★★}`, // 添加星星

          rich: {
            value: {
              fontSize: 25,

              color: '#000',
              lineHeight: 40
            },
            state: {
              fontSize: 13,
              color: '#000',
              lineHeight: 10
            },
            stars: { // 添加星星样式
              fontSize: 16,
              color: '#ff9900',
              lineHeight: 20
            }
          }
        },
        z: 1000// 确保数值在最上层
      }
    ]
  };
};

onMounted(() => {
  if (chartContainer.value) {
    myChart = echarts.init(chartContainer.value);
    myChart.setOption(getChartOptions());
  }

  const resizeHandler = () => myChart?.resize();
  window.addEventListener('resize', resizeHandler);

  onUnmounted(() => {
    window.removeEventListener('resize', resizeHandler);
    myChart?.dispose();
  });
});

watch(() => [props.value, props.title, props.state], () => {
  myChart?.setOption(getChartOptions());
});
</script>

<style scoped>
.gauge-container {
  width: 100%;
  height: 250px;
  ;
}


.rate-container {
  display: fixed;
  top: 80%;
  margin-top: 0px;
  /* 调整星星与 state 的间距 */
  text-align: center;
  /* 让星星居中 */
}
</style>